export default "__VITE_ASSET__DfRQbwpq__"